(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["page-side-menu"] && !Shopify.designMode) return;
  try {
    (function () {
    function scrollToActiveMenuItem() {
      var menus = document.querySelectorAll('.side-menu__list');
      menus.forEach(function (list) {
        var sideMenu = list.closest('.side-menu');
        var isTop = sideMenu && sideMenu.classList.contains('side-menu--top');

        /* Run for top position at any screen size, or for left/right only on mobile */
        if (!isTop && window.innerWidth > 989) return;

        var active = list.querySelector('.side-menu__link--active');
        if (!active) return;

        var listRect = list.getBoundingClientRect();
        var activeRect = active.getBoundingClientRect();
        var scrollLeft = list.scrollLeft + (activeRect.left - listRect.left) - listRect.width / 2 + activeRect.width / 2;

        list.scrollTo({ left: scrollLeft, behavior: 'instant' });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scrollToActiveMenuItem);
    } else {
      scrollToActiveMenuItem();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
